import React, {Component, FC} from 'react';

import {
  ConditionUnregistrator,
  TooltipContext,
  TooltipContextProps,
} from '../../../../libs/shared/ui/src/components/tooltips/tooltipContext';

/*
 * Props.
 */

interface TooltipExplicitConditionProps {
  isEnabled?: boolean;
}

/*
 * Component.
 */

class TooltipExplicitConditionComponent extends Component<
  TooltipExplicitConditionProps & TooltipContextProps
> {
  private unregistrator?: ConditionUnregistrator;

  /*
   * Lifecycle.
   */

  componentDidMount() {
    this.unregistrator = this.props.registerCondition(this.isEnabled);
  }

  componentWillUnmount() {
    if (!this.unregistrator) {
      return;
    }

    this.unregistrator();
  }

  private readonly isEnabled = () => Boolean(this.props.isEnabled);

  /*
   * Render.
   */

  render() {
    return null;
  }
}

export const TooltipExplicitCondition: FC<TooltipExplicitConditionProps> = (props) => (
  <TooltipContext.Consumer>
    {(context) => <TooltipExplicitConditionComponent {...props} {...context} />}
  </TooltipContext.Consumer>
);
